<template>
  <div class="header" ref="header">
    <div class="sidebar-button" ref="menuIcon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" viewBox="0 0 448 512" class="icon">
        <path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"></path>
      </svg></div>
    <router-link to="/" class="site-name" @click.native="$root.sidebarShow && ($root.sidebarShow = false)">vue form layer</router-link>
    <div class="links" ref="links">
      <nav class="nav-links">
        <div class="nav-item">
          <a href="https://github.com/blryli/vue-form-layer/blob/master/VERSIONS.md" target="_blank" rel="noopener noreferrer" class="repo-link">
            更新日志
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound">
              <path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
              <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
            </svg>
          </a>
        </div>
        <div class="nav-item">
          <a href="https://github.com/blryli/vue-form-layer" target="_blank" rel="noopener noreferrer" class="repo-link">
            GitHub
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound">
              <path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
              <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
            </svg>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { on, off } from "../utils/dom";

export default {
  name: "header",
  methods: {
    appClick(e) {
      const sidebar = document.querySelector('.sidebar');
      const header = this.$refs.header;
      const trigger = this.$refs.menuIcon;
      if (!sidebar || !trigger || !e.target) return;
      if (trigger.contains(e.target)) {
        this.$root.sidebarShow = !this.$root.sidebarShow;
      } else if (sidebar.contains(e.target) || header.contains(e.target)) {
        return;
      } else if (this.$root.sidebarShow !== false) {
        this.$root.sidebarShow = false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      on(document.querySelector('#app'), "click", this.appClick);
    })
  },
  beforeDestroy() {
    on(document.querySelector('#app'), "click", this.appClick);
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 0 1rem;
  height: 60px;
  line-height: 60px;
  z-index: 20;
  border-bottom: 1px solid #eaecef;
}
.sidebar-button {
  display: inline-block;
  position: relative;
  top: 11px;
  padding: 8px;
  user-select: none;
  .icon {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
  }
}
.links {
  display: none;
}
.site-name {
  font-size: 1.3rem;
  font-weight: 600;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  color: #2c3e50;
}
.nav-links a {
  line-height: 1.4rem;
  color: inherit;
}
a {
  font-weight: 500;
  text-decoration: none;
}

.icon.outbound {
  color: #aaa;
  display: inline-block;
}

@media (min-width: 768px) {
  .header {
    padding: 0 1.5rem;
  }
  .sidebar-button {
    display: none;
  }
  .site-name {
    position: relative;
    left: 0;
    transform: translate(0, 0);
  }
  .links {
    padding-left: 1.5rem;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 0.9rem;
    position: absolute;
    right: 1.5rem;
    top: 0.7rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    .nav-links {
      flex: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      .nav-item {
        position: relative;
        display: inline-block;
        margin-left: 1.5rem;
        line-height: 2rem;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
@media (min-width: 992px) {
}
</style>




// WEBPACK FOOTER //
// src/layou/header.vue